import { createFileRoute } from "@tanstack/react-router";
import { getPublishedLegalDocument } from "@/lib/api/legal.functions";
import { LegalDocumentView } from "@/components/site/LegalDocumentView";

export const Route = createFileRoute("/privacy")({
  loader: () => getPublishedLegalDocument({ data: { slug: "privacy" } }),
  head: ({ loaderData }) => ({
    meta: [
      { title: loaderData?.metaTitle ?? "Privacy Policy — KS Lau & Co" },
      {
        name: "description",
        content:
          loaderData?.metaDescription ??
          "How KS Lau & Co and Butterworth Taxation Services Sdn. Bhd. collect, use and protect personal data in accordance with Malaysia's PDPA 2010.",
      },
      { property: "og:title", content: loaderData?.metaTitle ?? "Privacy Policy — KS Lau & Co" },
      {
        property: "og:description",
        content:
          loaderData?.metaDescription ??
          "Our approach to handling personal data with confidentiality and care.",
      },
    ],
  }),
  component: PrivacyPage,
});

function PrivacyPage() {
  const doc = Route.useLoaderData();
  return (
    <LegalDocumentView
      title={doc.title}
      contentHtml={doc.contentHtml}
      lastPublishedAt={doc.lastPublishedAt}
    />
  );
}
